module.exports = __webpack_public_path__ + "img/edit.a13b22f2.svg";